export default __webpack_public_path__ + "static/media/icon_policy_overview_step1-1.abbdeb8d.svg";